import { BALANCE } from '../constants';
import type { Simulation } from '../sim';
import type { Peep, Tier } from '../types';

export function tierWageCents(peep: Peep): number {
  // Mine jobs and industry jobs draw a full tier wage. Amenity staff live off
  // their building's takings, townsfolk owe the company nothing, and idle
  // hands cost nothing — but a town that farms pays its farmhands, which is
  // what keeps the Endures ledger honest after the ore is gone.
  if (peep.job !== 'miner' && peep.job !== 'hauler' && peep.job !== 'industry') return 0;
  return BALANCE.tierWageCents[peep.tier] ?? BALANCE.tierWageCents[0];
}

export function tierSpeed(peep: Peep): number {
  return BALANCE.tierSpeed[peep.tier] ?? 1;
}

const TIER_NAMES = ['Transient', 'Regular', 'Veteran', 'Settler'] as const;

export function tierName(tier: Tier): string {
  return TIER_NAMES[tier];
}

/**
 * Weekly: tenure accrues only in decent-morale weeks, and workers climb
 * Transient -> Regular -> Veteran. Settler (tier 3) is reached only by
 * settling a family (families system).
 */
export function stepTiersWeekly(sim: Simulation): void {
  const state = sim.state;
  if (state.workforce.morale < BALANCE.tierMoraleGate) return;
  for (const peep of state.peeps) {
    if (peep.role === 'child') continue;
    // Townsfolk accrue tenure only while holding a real job — no promotion
    // parade for thirty settled spouses who never touched a pick or a plow.
    if (peep.role === 'spouse' && peep.job !== 'miner' && peep.job !== 'hauler' && peep.job !== 'industry')
      continue;
    peep.tenureWeeks += 1;
    if (peep.tier >= 2) continue;
    const nextTier = (peep.tier + 1) as 1 | 2;
    const needed = BALANCE.tierTenureWeeks[nextTier];
    if (peep.tenureWeeks >= needed) {
      peep.tier = nextTier;
      sim.pushEvent({ kind: 'promotion', peepName: peep.name, tier: nextTier });
      if (nextTier === 2) {
        sim.pushEvent({ kind: 'toast', message: `${peep.name} made Veteran.` });
        sim.firstVeteranSeen = true;
      }
    }
  }
}
